export const SET_LOADING = 'SET_LOADING';
export const SET_BUYERS_REPORT_DATA = 'SET_BUYERS_REPORT_DATA';

export const SET_SELECTED_ORGANIZATION_DATA = 'SET_SELECTED_ORGANIZATION_DATA';
